







































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { ApiRequest, AddDriverRequest, Document, Address } from '../../types/request';
import { validationMixin } from 'vuelidate';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { LoaderEvent, ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { Driver, ServiceRequest, TransporterLoc } from '../../types/entity';
import { ApiResponse, UploadFileResponse } from '@/types/response';
import { DateUtils } from '@/util/dateUtils';
import { ModelSelect } from 'vue-search-select';
// tslint:disable-next-line: no-var-requires
const ProfileFormData = require('../../config/ProfileFormData');
// tslint:disable-next-line: no-var-requires
const TimeZones = require('../../config/timezones.json');
declare var google: any;

@Component({
    mixins: [validationMixin],
    props: {
        transportId: String,
    },
    components: {
            ModelSelect,
    },
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',
            licenceNumber: '',
            licenceState: '',
            birthDate: '',
            timezone: '',
            locationId: '',
            branchName: '',
            expireDate: '',
            address: {
                fullAddress: '',
                locality: '',
                state: '',
                city: '',
                zip: '',
            },
            licenceStates: ProfileFormData.licenceStates,
            options: [],
            locationOptions: [],
        };
    },
    validations: {
        fullName: {
            required,
            regex: (fullName) => /^[a-zA-Z ]+$/.test(fullName),
        },
        phone: {
            required,
            minLength: minLength(10),
            regex: (phone) => MedTransGoConstants.PHONE_REGX.test(phone),
        },
        email: {
            email,
            required,
        },
        licenceNumber: {
            required,
        },
        licenceState: {
            required,
        },
        birthDate: {
            required,
        },
        timezone: {},
        expireDate: {
            required,
        },
        address: {
            fullAddress: {
                required,
            },
            locality: {},
            state: {
                required,
            },
            city: {
                required,
            },
            zip: {
                required,
            },
        },
    },
})

export default class AddDriverModal extends Vue {
    private locationGoogleAddress: any;
    private show = true;
    private addDriverRequest: AddDriverRequest | any;
    private documents: Document[] = [];
    private locations: TransporterLoc[] | undefined = [];
    private maxDate = new Date();
    private TimeZones = TimeZones;
    private isInvalidValidTime = false;
    private isLastMinuteRequest = false;
    private supportedFormats = [
        'image/png',
        'image/jpeg',
        'application/pdf',
    ];
    public mounted() {
        this.$data.options = [];
        this.getLocation();
        this.getGoogleAddress();

        this.maxDate.setFullYear(this.maxDate.getFullYear() - 23);
        this.$data.licenceStates.forEach((licenceState: any) => {
                const option = {
                    value: licenceState.name,
                    text: licenceState.name,
                };
                this.$data.options.push(option);
            });

    }

    /**
     * @author <Aniket.P>
     * @description - google places
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - google places suggession
     * @returns google places suggession
     * @throws InvalidRequestException if network error
     */
    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.locationGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('driverAddress'), {
                types: ['geocode'],
            },
            );
            this.locationGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(this.locationGoogleAddress);
            });
        });
    }


    /**
     * @author <shraddha.K>
     * @description - add new driver
     * @param req {Request} - calls add driver API
     * @param res {Response} - Express Response - success result
     * @returns success massage
     * @throws InvalidRequestException if driver already exists
     */
    private async addDriver() {
        const promises: Array<Promise<ApiResponse<UploadFileResponse>>> = [];
        const indexes: number[] = [];
        let index = 0;
        this.documents.forEach((document) => {
            if (document.file) {
                indexes.push(index);
                promises.push(ObjectFactory.getFileService()
                    .uploadFile(document.file, this.$store.state.serverUrl));
            }
            index++;
        });
        if (promises.length >= 1) {
            const loaderEvent: LoaderEvent = {
                show: true,
                message: 'Uploading',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_LOADER, loaderEvent);
            Promise.all(promises).then((uploadDocumentResponses) => {
                let indexTemp = 0;
                uploadDocumentResponses.forEach((uploadDocumentResponse) => {
                    const documentIndex = indexes[indexTemp];
                    const document = this.documents[documentIndex];
                    delete document.file;
                    if (uploadDocumentResponse.data) {
                        document.resourceId = uploadDocumentResponse.data.fileName;
                    }
                    indexTemp++;
                });
                this.callAddDriverApi();
            });
        } else {
            this.callAddDriverApi();
        }
    }

    private async callAddDriverApi() {
        let allDocumentUploaded = true;
        this.documents.forEach((element) => {
            if (!element.resourceId) {
                allDocumentUploaded = false;
            }
        });
        if (allDocumentUploaded) {
            const iHttpService = ObjectFactory.getHttpService();
            const addDriverRequest: AddDriverRequest = {
              fullName: this.$data.fullName,
              email: this.$data.email,
              phone: this.$data.phone,
              birthDate: this.$data.birthDate,
              expireYear: this.$data.expireDate,
              licenceNo: this.$data.licenceNumber,
              licenceState: this.$data.licenceState,
              address: this.$data.address,
              documents: this.documents,
              timezone: this.$data.timezone,
              branchName: this.$data.branchName,
              locationId: this.$data.locationId,
            };
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/add`,
                data: addDriverRequest,
                loaderEvent: {
                    show: true,
                },
            };
            const response = await iHttpService.post<Driver>(apiRequest);
            if (response.success) {
                const toastEvent: ToastEvent = {
                    message: CommonUtils.translateMessageCode('MSG_ADD_DRIVER'),
                    title: 'Success!',
                    timeout: 2000,
                    varient: 'success',
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                this.$emit('success');
                this.close();
            } else {
                CommonUtils.showError(response);
            }
        }
    }

    private async handleDocumentSelect(file: any, filename: string, description?: string, refId?: string) {
        const fileName = file.target.files[0].name.toLowerCase();
        if (fileName.endsWith('.pdf') || fileName.endsWith('.png') ||
            fileName.endsWith('.jpeg') || fileName.endsWith('.jpg')) {
            const formData = new FormData();
            formData.append('file', file.target.files[0]);
            this.documents.push({
                description,
                file: formData,
                name: filename,
                resourceId: '',
                filename: file.target.files[0].name,
            });
        } else {
            const toastEvent: ToastEvent = {
                message: 'File types should be PDF, JPEG, PNG',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            if (refId) {
                const element = this.$refs[refId] as any;
                element.reset();
            }
        }
    }

    private close() {
        if (this.$route.path === `${MedTransGoConstants.URL_SETTING}/${MedTransGoConstants.URL_ADD_DRIVER}`) {
            this.$router.push({
                name: MedTransGoConstants.VIEW_SETTING_NAME,
            });
        } else {
            this.$emit('close');
        }
    }

    private async getLocation() {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/location/list`,
                loaderEvent: {
                    show: true,
                },
            };
        const response = await iHttpService.get<TransporterLoc[]>(apiRequest);
        if (response.success && response.data) {
                this.$data.locationOptions = [];
                this.locations = response.data as any;
                response.data.forEach((location) => {
                const option = {
                    value: location.id,
                    text: location.branchName,
                };
                this.$data.locationOptions.push(option);
                });
            } else {
                CommonUtils.showError(response);
            }
    }
     private getTimezoneRequests(result: ServiceRequest[]) {
        result.forEach((element: any) => {
            const appointmentTimestamp =
            DateUtils.convertToUTCInMillis(element.transporterProfile.appointmentDate + ' ' +
            element.transporterProfile.appointmentTime, element.appointment.timezone);
            const appointmentTime = DateUtils.formatDate(appointmentTimestamp,
            DateUtils.FORMAT_DATETIME_AM_PM, element.appointment.timezone);
            element.transporterProfile.appointmentDate = appointmentTime;
            element.appointment.timestamp =
                DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM);
            element.createdOn = DateUtils.formatDate(element.createdOn, DateUtils.FORMAT_DATETIME_AM_PM);
        });
        this.addDriverRequest.data = result;
    }

    private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }

}
